import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const emoteEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/emotes?${buildAdminListQuery(params)}`, // GET
  detail: (id: string) => `/admin/emotes/${id}`, // GET
  presign: '/admin/emotes/presign', // POST (D6: get S3 PUT url)
  finalize: '/admin/emotes/finalize', // POST (D6: register uploaded key)
  edit: (id: string) => `/admin/emotes/${id}`, // PATCH (name? + presigned key?)
  active: (id: string) => `/admin/emotes/${id}/active`, // PATCH
  delete: (id: string) => `/admin/emotes/${id}`, // DELETE
}

export const emoteBackendErrors = {
  EMOTE_NOT_FOUND: 'Emoji bulunamadı!',
  EMOTE_EXISTS: 'Bu emoji çoktan oluşturulmuş!',
  EMOTE_CREATE: 'Emoji oluşturulurken hata oluştu!',
  EMOTE_EDIT: 'Emoji düzenlenirken hata oluştu!',
  EMOTE_DELETE: 'Emoji silinirken hata oluştu!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
}

export const emoteSuccessMessages = {
  emoteCreate: 'Emoji başarıyla oluşturuldu!',
  emoteEdit: 'Emoji başarıyla düzenlendi!',
  emoteActive: 'Emoji aktiflik durumu güncellendi!',
  emoteDelete: 'Emoji başarıyla silindi!',
}
